import React, { useState, useEffect } from "react";
import { requestAuth } from "../../components/services/RequestService";
import FillForm from "../../containers/steps/FillForm";
import { useAuth } from "../../contexts/AuthContext";

export const FillFormByStep = (props) => {
  const { procedure, onClose, openModal, reload, targetStepNumber } = props;
  const [targetStepId, setTargetStepId] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    requestAuth("get", `/processstep/GetProcessStepsByProcedureTypeId/${procedure.procedureTypeId}`)
      .then((res) => {
        const targetStep = res.data.find((s) => parseInt(s.step) === parseInt(targetStepNumber));
        if (targetStep) {
          setTargetStepId(targetStep.id);
        } else {
          console.error(`No se encontro el paso ${targetStepNumber}`);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error obteniendo pasos", err);
        setLoading(false);
      });
  }, [procedure.procedureTypeId, targetStepNumber]);

  if (loading) {
    return <div className="p-10 text-center">Cargando formulario del paso {targetStepNumber}...</div>;
  }

  if (!targetStepId) {
    return <div className="p-10 text-center text-red-500">Este tipo de trámite no tiene un Paso {targetStepNumber} configurado.</div>;
  }

  const fakeProcedure = {
    ...procedure,
    processStepId: targetStepId,
  };

  return (
    <FillForm
      procedure={fakeProcedure}
      reload={reload}
      onClose={onClose}
      openModal={openModal}
      rolId={user?.rolId}
      step={targetStepNumber.toString()}
      typeId={procedure.procedureTypeId}
    />
  );
};
